import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MigrationHistoryComponent } from './migration-history.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ComponentsModule } from 'src/app/components/components.module';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';



@NgModule({
  declarations: [
    MigrationHistoryComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ComponentsModule,
    DateDefaultFormatPipe
  ],
  exports:[
    MigrationHistoryComponent
  ]
})
export class MigrationHistroyModule { }
